import React from 'react';
import { Button } from '@moda/om';
import { ADD_TO_BAG_FRAGMENT, useAddToBag, UseAddToBagProps } from '../../hooks/useAddToBag';
import './AddToBagButton.scss';

export { ADD_TO_BAG_FRAGMENT };

export type AddToBagButtonProps = UseAddToBagProps & {
  className?: string;
};

export const AddToBagButton: React.FC<AddToBagButtonProps> = ({ className, ...rest }) => {
  const { disabled, error, handleAddToBag, text } = useAddToBag(rest);

  return (
    <Button
      className={className}
      aria-label={text}
      disabled={disabled}
      secondary={error}
      onClick={handleAddToBag}
    >
      {text}
    </Button>
  );
};
